export default {
  brand: "USFansLink",
  nav: {
    spreadsheets: "Arkusze",
    products: "Produkty",
    sellers: "Sprzedawcy",
    reviews: "Opinie",
    shipping: "Wysyłka",
    coupons: "Kupony",
    guides: "Poradniki",
    safety: "Bezpieczeństwo",
    buyNow: "Kup teraz",
    home: "Strona główna",
    shoppingGuide: "Poradnik zakupowy",
    categories: "Kategorie",
    chooseLanguage: "Język",
  },
  hero: {
    badge: "Niezależne źródło • Aktualizowane poradniki • Wsparcie wielojęzyczne",
    title: "Arkusz USFans – znajdź produkty, sprzedawców i poradniki zakupowe",
    subtitle:
      "Poznaj arkusz USFans, aby odkryć przydatne listy produktów, zasoby sprzedawców, poradniki zakupowe, informacje o wysyłce, wskazówki QC i najnowsze zasoby USFans — wszystko w jednym wygodnym miejscu.",
    ctaPrimary: "Arkusz USFans",
    ctaSecondary: "Kup teraz",
    hint: "Otwiera oficjalny sklep USFans w nowej karcie",
  },
  categories: {
    title: "Przeglądaj produkty według kategorii",
    subtitle:
      "Przejdź od razu do potrzebnej kategorii. Każdy link otwiera sklep USFans, dzięki czemu możesz kontynuować zakupy bez kłopotu.",
    dropdownLabel: "Wybierz kategorię",
    dropdownPlaceholder: "Wybierz kategorię…",
    openLabel: "Zobacz kategorię",
    shoes: "Buty",
    hoodies: "Bluzy i swetry",
    tshirts: "Koszulki",
    jackets: "Kurtki",
    pants: "Spodnie i szorty",
    headwear: "Nakrycia głowy",
    sets: "Zestawy",
    underwear: "Bielizna i bokserki",
    jerseys: "Koszulki sportowe",
    accessories: "Akcesoria",
    bags: "Torby",
    belts: "Paski",
    perfumes: "Perfumy",
    other: "Inne",
  },
  resources: {
    title: "Wszystko, czego potrzebujesz do researchu produktów USFans",
    subtitle:
      "Szukanie produktów, sprzedawców lub przydatnych informacji o USFans bywa czasochłonne. USFansLink porządkuje ważne zasoby w przejrzyste arkusze, poradniki, porównania i samouczki, dzięki czemu badanie produktów jest szybsze i pomaga podejmować lepsze decyzje.",
    cards: {
      spreadsheet: { title: "Arkusz USFans", desc: "Uporządkowane informacje o produktach i sprzedawcach w jednym przejrzystym widoku." },
      productLists: { title: "Listy produktów", desc: "Wybrane listy, które pomagają szybko porównywać produkty w różnych kategoriach." },
      sellerGuides: { title: "Poradniki sprzedawców", desc: "Praktyczne wskazówki, jak badać sprzedawców i czytać ich historię." },
      shippingGuides: { title: "Poradniki wysyłki", desc: "Jasne wyjaśnienia opcji wysyłki, kosztów i czasu dostawy." },
      qcResources: { title: "Zasoby QC", desc: "Listy kontrolne i wskazówki dotyczące zdjęć, by sprawdzić jakość przed zakupem." },
      safetyGuides: { title: "Poradniki bezpieczeństwa", desc: "Bezpieczeństwo konta, podejrzane linki i świadomość płatności w jednym miejscu." },
    },
  },
  spreadsheet: {
    title: "Arkusz USFans",
    text: "Zacznij od arkusza USFans, aby poznać uporządkowane informacje o produktach i sprzedawcach. Używaj filtrów, kategorii i poradników pomocniczych, aby zawęzić to, czego szukasz, zanim podejmiesz decyzję.",
    cta: "Otwórz poradnik arkusza",
  },
  popular: {
    title: "Popularne zasoby USFans",
    subtitle: "Szybki dostęp do tematów, których kupujący szukają najczęściej.",
    comingSoon: "Poradnik wkrótce",
    cards: {
      review: { title: "Opinia o USFans", desc: "Niezależne spojrzenie na funkcje, przebieg zakupów i ogólne doświadczenia." },
      shippingCost: { title: "Koszt wysyłki USFans", desc: "Jak opcje i koszty wysyłki mogą się różnić w zależności od miejsca docelowego." },
      coupon: { title: "Kupon USFans", desc: "Gdzie szukać bieżących ofert i jak je zastosować." },
      discountCode: { title: "Kod rabatowy USFans", desc: "Wskazówki, jak znaleźć dostępne promocje przed finalizacją zamówienia." },
      warehouse: { title: "Magazyn USFans", desc: "Jak procesy magazynowe wpływają na dostawę." },
      legit: { title: "Czy USFans jest legalne?", desc: "Zrównoważony poradnik o zaufaniu i bezpieczeństwie." },
    },
  },
  confidence: {
    title: "Badaj produkty z większą pewnością",
    text: "Używaj informacji o produktach, researchu sprzedawców, zasobów QC i poradników wysyłki razem, zamiast polegać na jednym źródle. Naszym celem jest uczynienie procesu researchu łatwiejszym do zrozumienia.",
  },
  shipping: {
    title: "Poradniki wysyłki, magazynu i dostawy USFans",
    text: "Dowiedz się, jak opcje wysyłki, procesy magazynowe i kwestie dostawy mogą wpływać na Twoje doświadczenia zakupowe.",
    cta: "Przeglądaj poradniki wysyłki",
  },
  review: {
    title: "Opinia i poradnik doświadczeń USFans",
    text: "Szukasz opinii o USFans? Poznaj nasze niezależne poradniki obejmujące funkcje platformy, przebieg zakupów, wysyłkę, informacje o magazynie, kwestie bezpieczeństwa i najczęstsze pytania.",
    cta: "Przeczytaj opinię o USFans",
  },
  safety: {
    title: "Centrum bezpieczeństwa USFans",
    text: "Zanim skorzystasz z jakiejkolwiek platformy zakupowej lub zasobów sprzedawcy, poznaj potencjalne ryzyko. Nasze Centrum Bezpieczeństwa obejmuje bezpieczeństwo konta, research sprzedawców, kontrole QC, świadomość płatności, kwestie wysyłki i podejrzane linki.",
    cta: "Odwiedź Centrum Bezpieczeństwa",
  },
  guides: {
    title: "Najnowsze poradniki arkusza USFans",
    subtitle: "Świeże, oryginalne poradniki, które pomogą Ci mądrzej badać produkty.",
    readMore: "Czytaj poradnik",
    article: {
      title: "Czym jest arkusz USFans? Kompletny przewodnik",
      excerpt:
        "Dowiedz się, czym jest arkusz USFans, co zawiera, jak go używać do znajdowania produktów i sprzedawców oraz co warto wiedzieć o wysyłce, QC i bezpieczeństwie przed zakupem.",
      tag: "Poradnik dla początkujących",
    },
    moreSoon: "Wkrótce pojawią się kolejne poradniki — wysyłka, kupony, magazyn i pogłębione opinie.",
  },
  faq: {
    title: "Często zadawane pytania",
    subtitle: "Szybkie odpowiedzi na pytania najczęściej zadawane o arkuszu USFans.",
    questions: {
      q1: "Czym jest arkusz USFans?",
      a1: "To uporządkowane źródło, które łączy listy produktów, informacje o sprzedawcach i kategorie w jednym widoku, dzięki czemu możesz porównywać opcje bez przeskakiwania między wieloma stronami.",
      q2: "Jak używać arkusza USFans?",
      a2: "Wybierz kategorię, a następnie filtruj lub sortuj kolumny, które Cię interesują, np. cenę lub wysyłkę. Gdy zawęzisz opcje, skorzystaj z linków do produktów, aby kontynuować w głównym sklepie.",
      q3: "Czy USFans jest legalne?",
      a3: "USFans to platforma zakupowa używana przez wielu kupujących. Jak w każdym sklepie, badaj sprzedawców, przeglądaj zdjęcia QC i zachowaj ostrożność przy nietypowych prośbach o płatność przed zakupem.",
      q4: "Ile kosztuje wysyłka USFans?",
      a4: "Koszty wysyłki różnią się w zależności od sprzedawcy, miejsca docelowego i metody. Zawsze potwierdź ostateczny koszt w kolumnie wysyłki lub przy kasie przed złożeniem zamówienia.",
      q5: "Czy USFans ma kupony?",
      a5: "Oferty i kody rabatowe pojawiają się i znikają. Sprawdź najnowsze zasoby kuponów i kodów rabatowych przed kasą, ponieważ kod może działać tylko dla określonych kategorii lub minimalnych zamówień.",
      q6: "Gdzie jest magazyn USFans?",
      a6: "Lokalizacje i procesy magazynowe mogą się różnić. Sprawdź notatki magazynowe sprzedawcy, od którego kupujesz, aby zrozumieć czas przechowywania i dostawy.",
      q7: "Jak badać sprzedawców USFans?",
      a7: "Sprawdź historię sprzedawcy, przeczytaj opinie, obejrzyj zdjęcia QC, jeśli są dostępne, i zweryfikuj szczegóły wysyłki i płatności przed podjęciem decyzji o zakupie.",
    },
  },
  finalCta: {
    title: "Rozpocznij research USFans",
    text: "Poznaj arkusz USFans, porównaj przydatne zasoby i kontynuuj badanie produktów z naszymi najnowszymi poradnikami.",
    cta: "Poznaj arkusz USFans",
  },
  notFound: {
    title: "Ta strona nie została jeszcze wygenerowana",
    subtitle: "Powiedz nam więcej o tej stronie, a wygenerujemy ją dla Ciebie.",
    backHome: "Wróć na stronę główną",
  },
  footer: {
    about: "O nas",
    contact: "Kontakt",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
    editorial: "Polityka redakcyjna",
    updates: "Aktualizacje",
    disclaimer:
      "USFansLink jest niezależnym źródłem informacyjnym i nie jest powiązany z USFans ani przez niego zatwierdzony, chyba że wyraźnie stwierdzono inaczej.",
    rights: "Wszelkie prawa zastrzeżone.",
  },
};